const parseToCsvSafeValue = (str: string) => {
  //Adapted from: https://codepen.io/dcode-software/pen/WBGOyd

  let parsedValue = str;

  // Replace all double quotes with two double quotes
  parsedValue = parsedValue.replace(/"/g, `""`);

  // If value contains comma, new-line or double-quote, enclose in double quotes
  parsedValue = /[",\n]/.test(parsedValue) ? `"${parsedValue}"` : parsedValue;

  return parsedValue;
};

export const parseTableToCSV = (str: string) => {
  return str
    .split('\n')
    .map((row) => row.split('\t').map(parseToCsvSafeValue).join(','))
    .join('\n');
};

export const stringArrayToURLQueryParam = (key: string, value: string[]) => {
  return new URLSearchParams({ [key]: value.toString() }).toString();
};

export const toUpperSnakeCase = (str: string): string => {
  return str
    .trim() // Remove leading/trailing whitespace
    .replace(/([a-z])([A-Z])/g, '$1_$2') // Handle camelCase
    .replace(/\s+/g, '_') // Replace spaces with underscores
    .replace(/[^a-zA-Z0-9_]/g, '') // Remove special characters (optional)
    .toUpperCase(); // Convert to uppercase
};
